// ═══════════════════════════════════════════════════════════
// TV 模式检测与切换
// ═══════════════════════════════════════════════════════════

import { storage } from '../lib/storage.js';

export function initTVMode() {
    const TV_KEY = 'libretv_tv_mode';
    const isTV = () =>
        navigator.userAgent.includes('Android TV') ||
        navigator.userAgent.includes('SmartTV') ||
        /(AppleTV|Roku|Xbox|PlayStation|Nintendo|Tizen|Web0S)/i.test(navigator.userAgent) ||
        (screen.width >= 1280 && screen.height >= 720 && !('ontouchstart' in window));

    if (isTV() || storage.tvMode === '1') {
        document.body.classList.add('tv-mode');
    }

    // 允许通过 URL 参数手动切换
    const params = new URLSearchParams(location.search);
    if (params.get('tv') === '1') {
        document.body.classList.add('tv-mode');
        storage.tvMode = '1';
    }
    if (params.get('tv') === '0') {
        document.body.classList.remove('tv-mode');
        storage.tvMode = '0';
    }
}
